const NavigateActionTypes = {
    BACK: "back",
    // PUSH: 'push',
    // POP: 'pop',
    // GO: 'go',
    // RESET: "reset",
};

export default NavigateActionTypes;